/* MOUV - wedding cursor trail: rose petals follow the pointer.
   Desktop pointers only. Disabled for reduced-motion visitors. */
(function () {
  if (!document.body.classList.contains('section--wedding')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(pointer: fine)').matches) return;

  var ART = ["data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20120%20100%22%3E%3Cdefs%3E%3CradialGradient%20id%3D%22g1%22%20cx%3D%2234%25%22%20cy%3D%2228%25%22%20r%3D%2280%25%22%3E%3Cstop%20offset%3D%220%25%22%20stop-color%3D%22%23ffffff%22%2F%3E%3Cstop%20offset%3D%2230%25%22%20stop-color%3D%22%23fde4ef%22%2F%3E%3Cstop%20offset%3D%2266%25%22%20stop-color%3D%22%23f9a8cd%22%2F%3E%3Cstop%20offset%3D%22100%25%22%20stop-color%3D%22%23e04b95%22%2F%3E%3C%2FradialGradient%3E%3C%2Fdefs%3E%3Cpath%20fill%3D%22url%28%23g1%29%22%20d%3D%22M10%2058C4%2038%2020%2014%2048%207c26-7%2054%202%2064%2020%209%2016%202%2034-18%2045C72%2084%2040%2092%2024%2084%2015%2079%2012%2070%2010%2058Z%22%2F%3E%3Cpath%20fill%3D%22%23fff%22%20opacity%3D%22.26%22%20d%3D%22M28%2030c11-11%2032-17%2050-14-17%202-33%209-43%2019-9%209-13%2019-12%2029-6-12-5-24%205-34Z%22%2F%3E%3C%2Fsvg%3E", "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20120%20100%22%3E%3Cdefs%3E%3CradialGradient%20id%3D%22g2%22%20cx%3D%2244%25%22%20cy%3D%2224%25%22%20r%3D%2280%25%22%3E%3Cstop%20offset%3D%220%25%22%20stop-color%3D%22%23ffffff%22%2F%3E%3Cstop%20offset%3D%2230%25%22%20stop-color%3D%22%23fcd8e8%22%2F%3E%3Cstop%20offset%3D%2266%25%22%20stop-color%3D%22%23f58ec0%22%2F%3E%3Cstop%20offset%3D%22100%25%22%20stop-color%3D%22%23d63f8c%22%2F%3E%3C%2FradialGradient%3E%3C%2Fdefs%3E%3Cpath%20fill%3D%22url%28%23g2%29%22%20d%3D%22M60%204c26%2020%2042%2046%2034%2068-7%2020-45%2026-64%2010C11%2066%2012%2030%2060%204Z%22%2F%3E%3Cpath%20fill%3D%22%23fff%22%20opacity%3D%22.26%22%20d%3D%22M56%2016C34%2034%2026%2056%2032%2074c-8-18-2-42%2024-58Z%22%2F%3E%3C%2Fsvg%3E", "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20120%20100%22%3E%3Cdefs%3E%3CradialGradient%20id%3D%22g3%22%20cx%3D%2262%25%22%20cy%3D%2234%25%22%20r%3D%2280%25%22%3E%3Cstop%20offset%3D%220%25%22%20stop-color%3D%22%23ffffff%22%2F%3E%3Cstop%20offset%3D%2230%25%22%20stop-color%3D%22%23fbe3ef%22%2F%3E%3Cstop%20offset%3D%2266%25%22%20stop-color%3D%22%23f79cc6%22%2F%3E%3Cstop%20offset%3D%22100%25%22%20stop-color%3D%22%23cf3d86%22%2F%3E%3C%2FradialGradient%3E%3C%2Fdefs%3E%3Cpath%20fill%3D%22url%28%23g3%29%22%20d%3D%22M14%2062C6%2042%2024%2012%2054%206c28-6%2052%208%2056%2028%204%2020-16%2040-44%2050C40%2092%2020%2082%2014%2062Z%22%2F%3E%3Cpath%20fill%3D%22%23fff%22%20opacity%3D%22.26%22%20d%3D%22M96%2030c-10%2022-34%2040-62%2046%2024%202%2052-14%2062-34Z%22%2F%3E%3C%2Fsvg%3E", "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20120%20100%22%3E%3Cdefs%3E%3CradialGradient%20id%3D%22g4%22%20cx%3D%2238%25%22%20cy%3D%2232%25%22%20r%3D%2280%25%22%3E%3Cstop%20offset%3D%220%25%22%20stop-color%3D%22%23ffffff%22%2F%3E%3Cstop%20offset%3D%2230%25%22%20stop-color%3D%22%23fdeaf3%22%2F%3E%3Cstop%20offset%3D%2266%25%22%20stop-color%3D%22%23f7b3d4%22%2F%3E%3Cstop%20offset%3D%22100%25%22%20stop-color%3D%22%23e35ba0%22%2F%3E%3C%2FradialGradient%3E%3C%2Fdefs%3E%3Cpath%20fill%3D%22url%28%23g4%29%22%20d%3D%22M60%208c30%200%2050%2020%2050%2042s-22%2042-50%2042S10%2072%2010%2050%2030%208%2060%208Z%22%2F%3E%3Cpath%20fill%3D%22%23fff%22%20opacity%3D%22.26%22%20d%3D%22M34%2026c10-9%2026-13%2040-11-13%201-26%206-34%2014-7%207-10%2015-9%2023-5-9-4-19%203-26Z%22%2F%3E%3C%2Fsvg%3E", "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20120%20100%22%3E%3Cdefs%3E%3CradialGradient%20id%3D%22g5%22%20cx%3D%2250%25%22%20cy%3D%2226%25%22%20r%3D%2280%25%22%3E%3Cstop%20offset%3D%220%25%22%20stop-color%3D%22%23ffffff%22%2F%3E%3Cstop%20offset%3D%2230%25%22%20stop-color%3D%22%23fce0ee%22%2F%3E%3Cstop%20offset%3D%2266%25%22%20stop-color%3D%22%23f591c2%22%2F%3E%3Cstop%20offset%3D%22100%25%22%20stop-color%3D%22%23d4408d%22%2F%3E%3C%2FradialGradient%3E%3C%2Fdefs%3E%3Cpath%20fill%3D%22url%28%23g5%29%22%20d%3D%22M60%2096C24%2074%206%2052%2012%2030%2017%2012%2040%204%2060%2020%2080%204%20103%2012%20108%2030c6%2022-12%2044-48%2066Z%22%2F%3E%3Cpath%20fill%3D%22%23fff%22%20opacity%3D%22.26%22%20d%3D%22M58%2030C46%2018%2030%2016%2022%2026c10-6%2024-2%2036%2010Z%22%2F%3E%3C%2Fsvg%3E", "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20120%20100%22%3E%3Cdefs%3E%3CradialGradient%20id%3D%22g6%22%20cx%3D%2240%25%22%20cy%3D%2220%25%22%20r%3D%2280%25%22%3E%3Cstop%20offset%3D%220%25%22%20stop-color%3D%22%23ffffff%22%2F%3E%3Cstop%20offset%3D%2230%25%22%20stop-color%3D%22%23fbdcea%22%2F%3E%3Cstop%20offset%3D%2266%25%22%20stop-color%3D%22%23f280b6%22%2F%3E%3Cstop%20offset%3D%22100%25%22%20stop-color%3D%22%23c9367f%22%2F%3E%3C%2FradialGradient%3E%3C%2Fdefs%3E%3Cpath%20fill%3D%22url%28%23g6%29%22%20d%3D%22M62%202c22%2026%2034%2052%2024%2072-9%2018-42%2022-58%206C10%2062%2018%2026%2062%202Z%22%2F%3E%3C%2Fsvg%3E"];

  var layer = document.createElement('div');
  layer.className = 'mouv-trail';
  layer.setAttribute('aria-hidden', 'true');
  document.body.appendChild(layer);

  var last = 0, lx = 0, ly = 0, live = 0;
  var MIN_GAP = 55;      // ms between petals
  var MIN_DIST = 26;     // px the pointer must travel
  var MAX_LIVE = 26;     // hard cap on petals on screen

  document.addEventListener('mousemove', function (e) {
    var now = e.timeStamp || Date.now();
    if (now - last < MIN_GAP || live >= MAX_LIVE) return;
    var dx = e.clientX - lx, dy = e.clientY - ly;
    if (dx * dx + dy * dy < MIN_DIST * MIN_DIST) return;
    last = now; lx = e.clientX; ly = e.clientY;
    spawn(e.clientX, e.clientY, dx);
  }, { passive: true });

  function spawn(x, y, dx) {
    var el = document.createElement('i');
    var size = 11 + Math.random() * 13;
    el.style.backgroundImage = 'url("' + ART[(Math.random() * ART.length) | 0] + '")';
    el.style.width = size + 'px';
    el.style.height = size * 0.82 + 'px';
    el.style.left = (x - size / 2) + 'px';
    el.style.top = (y - size / 2) + 'px';
    // drift away from the direction of travel, then fall
    var driftX = (dx > 0 ? -1 : 1) * (14 + Math.random() * 34);
    var fall = 60 + Math.random() * 70;
    var spin = (Math.random() * 460 - 230) | 0;
    el.style.setProperty('--tx', driftX.toFixed(1) + 'px');
    el.style.setProperty('--ty', fall.toFixed(1) + 'px');
    el.style.setProperty('--rot', spin + 'deg');
    el.style.animationDuration = (1500 + Math.random() * 900) + 'ms';
    layer.appendChild(el);
    live++;
    el.addEventListener('animationend', function () {
      el.remove(); live--;
    });
  }
})();


/* ---------------------------------------------------------------------------
   CORPORATE - crisp scroll reveal + precision cursor ring
   --------------------------------------------------------------------------- */
(function () {
  if (!document.body.classList.contains('section--corporate')) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine   = window.matchMedia('(pointer: fine)').matches;

  /* ---- scroll reveal ---- */
  if (!reduce && 'IntersectionObserver' in window) {
    var cards = document.querySelectorAll('.grid-item.grid-product');
    if (cards.length) {
      for (var i = 0; i < cards.length; i++) cards[i].classList.add('mouv-reveal');
      var io = new IntersectionObserver(function (entries) {
        for (var j = 0; j < entries.length; j++) {
          var e = entries[j];
          if (!e.isIntersecting) continue;
          var el = e.target;
          var row = Array.prototype.indexOf.call(el.parentNode.children, el) % 4;
          el.style.transitionDelay = (row * 45) + 'ms';
          el.classList.add('is-in');
          io.unobserve(el);
        }
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      for (var k = 0; k < cards.length; k++) io.observe(cards[k]);
    }
  }

  /* ---- precision cursor ring ---- */
  if (reduce || !fine) return;

  var ring = document.createElement('div');
  ring.className = 'mouv-ring';
  ring.setAttribute('aria-hidden', 'true');
  var dot = document.createElement('div');
  dot.className = 'mouv-ring__dot';
  dot.setAttribute('aria-hidden', 'true');
  document.body.appendChild(ring);
  document.body.appendChild(dot);

  var tx = 0, ty = 0, rx = 0, ry = 0, running = false;

  document.addEventListener('mousemove', function (e) {
    tx = e.clientX; ty = e.clientY;
    dot.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0)';
    if (!ring.classList.contains('is-on')) {
      rx = tx; ry = ty;
      ring.classList.add('is-on');
      dot.classList.add('is-on');
    }
    if (!running) { running = true; requestAnimationFrame(loop); }
  }, { passive: true });

  document.addEventListener('mouseleave', function () {
    ring.classList.remove('is-on');
    dot.classList.remove('is-on');
  });

  function loop() {
    rx += (tx - rx) * 0.16;          /* lag behind the pointer */
    ry += (ty - ry) * 0.16;
    ring.style.transform = 'translate3d(' + rx.toFixed(2) + 'px,' + ry.toFixed(2) + 'px,0)';
    if (Math.abs(tx - rx) > 0.4 || Math.abs(ty - ry) > 0.4) {
      requestAnimationFrame(loop);
    } else { running = false; }
  }

  /* expand over anything interactive */
  var SEL = '.grid-item.grid-product, a, button, .btn, input, select';
  document.addEventListener('mouseover', function (e) {
    if (e.target.closest && e.target.closest(SEL)) ring.classList.add('is-over');
  }, { passive: true });
  document.addEventListener('mouseout', function (e) {
    if (e.target.closest && e.target.closest(SEL)) ring.classList.remove('is-over');
  }, { passive: true });
})();
